// Utility function to build query string from an object of parameters
export function buildQueryString(options) {
  if (!options) {
    return "";
  }

  const searchParams = new URLSearchParams();

  for (const key in options) {
    if (options[key] !== undefined) {
      if (Array.isArray(options[key])) {
        options[key].forEach((value) => searchParams.append(key, `${value}`));
      } else {
        searchParams.append(key, `${options[key]}`);
      }
    }
  }

  return `?${searchParams}`;
}

// Utility function to extract query parameters from a URL string
export function extractQueryParams(pathOrParamString, defaultValue) {
  if (!pathOrParamString || !pathOrParamString.includes("=")) {
    return {};
  }

  let paramString;

  const splitIndex = pathOrParamString.indexOf("?");

  if (splitIndex < 0) {
    paramString = pathOrParamString;
  } else {
    paramString = pathOrParamString.substring(splitIndex + 1);
  }

  const searchParams = new URLSearchParams(paramString);

  const params = {};

  searchParams.forEach((value, key) => {
    const newValue = isNaN(Number(value)) || value === "" ? value : Number(value);
    if (!params[key] && !Array.isArray(defaultValue?.[key])) {
      params[key] = newValue;
    } else {
      if (Array.isArray(params[key])) {
        params[key].push(newValue);
      } else {
        params[key] = [newValue];
      }
    }
  });

  return params;
}

// Utility function to combine query parameters with replacement values
export function combineQueryParams(paramString, replacement) {
  const searchParams = new URLSearchParams(paramString);
  for (const key in replacement) {
    const value = replacement[key];
    if (value === undefined) {
      searchParams.delete(key);
    } else {
      if (Array.isArray(value)) {
        searchParams.delete(key);
        value.forEach((item) => searchParams.append(key, `${item}`));
      } else {
        searchParams.set(key, `${value}`);
      }
    }
  }
  return searchParams;
}
